import produce from 'immer';
import { put, takeLatest, delay } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { creator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */
// import { actions as tempNewOrderActions } from 'sagas/app/orders/tempNewOrderSaga';
// import { actions as workerActions } from 'sagas/app/workers/workerSaga';

/**
 * Constants
 */
export const REQUEST = '@app/newordersaga/REQUEST';
export const SUCCESS = '@app/newordersaga/SUCCESS';
export const FAILURE = '@app/newordersaga/FAILURE';
export const SET_LOADING = '@app/newordersaga/SET_LOADING';
export const SET_ITEMS = '@app/newordersaga/SET_ITEMS';
export const CLEAR = '@app/newordersaga/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: true,
    errorStatus: '',
    data: null
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.data = payload.data;
                draft.success = true;
                draft.loading = false;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case SET_LOADING:
                draft.loading = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.errorStatus = '';
                draft.data = null;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            yield put(creator(SET_LOADING, true));
            yield put(actions.clear());
            yield delay(400, true);
            const response = yield axios.post(
                `/orders?company_id=${payload.companyId}`,
                payload.data
            );

            yield put(actions.success(response.data));
            // yield put(tempNewOrderActions.clear());
            // yield put(workerActions.clear());
            yield put(push(`/orders/view/${response.data.data.id}`));
        } catch (e) {
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'Error: Something went wrong please contact support!';
            yield put(actions.failure(error));
            // yield put(creator(CLEAR));
        }

        yield put(creator(SET_LOADING, false));
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
